import type { AppRouteConfig } from '../../models'

import { FeatureIdEnum } from '../../enums'

import { RedirectionsForm, RedirectionsList } from '../../views'

import { ROUTER_CONSTS } from '../router.consts'
import { ACTIVE_FILTER_CONFIG } from '../routes.filters'
import { ROUTES_PATHS } from '../routes.paths'

const REDIRECTIONS_PATHS = Object.assign(ROUTES_PATHS, {
  redirections: 'redirections',
})

export const REDIRECTIONS_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.REDIRECTION].list,
    path: REDIRECTIONS_PATHS.redirections,
    component: RedirectionsList,
    meta: {
      featureId: FeatureIdEnum.REDIRECTION,
      filters: () => ({
        regularFiltersEnabled: true,
        extra: {
          [ACTIVE_FILTER_CONFIG.id]: ACTIVE_FILTER_CONFIG,
        },
      }),
      style: {
        removeContentPadding: true,
      },
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.REDIRECTION].create,
    path: `${REDIRECTIONS_PATHS.redirections}/${REDIRECTIONS_PATHS.actions.create}`,
    component: RedirectionsForm,
    meta: {
      featureId: FeatureIdEnum.REDIRECTION,
      titleI18nKey: 'createRedirection',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.REDIRECTION].list,
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.REDIRECTION].update,
    path: `${REDIRECTIONS_PATHS.redirections}/${REDIRECTIONS_PATHS.actions.update}`,
    component: RedirectionsForm,
    meta: {
      featureId: FeatureIdEnum.REDIRECTION,
      titleI18nKey: 'updateRedirection',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.REDIRECTION].list,
    },
  },
]
